import { Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import React from 'react';

import BranchSystemCreate from './BranchSystemCreate';

// eslint-disable-next-line react/function-component-definition
export default function CodingCreateDialog({
  onClose,
  open,
  guid,
  handleConfirm,
}) {
  return (
    <Dialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
      {open && guid ? (
        <Box sx={{ p: 3, direction: 'rtl' }}>
          <BranchSystemCreate
            branchGuid={guid}
            onEditComplete={handleConfirm}
          />
        </Box>
      ) : null}
    </Dialog>
  );
}
